// extracted by mini-css-extract-plugin
export default {"rootContainer":"Root_rootContainer__0UgYU"};